/**
 * Utility class added to the body element by full-screen components (e.g. EditorPage) to suppress navigation elements.
 * @see https://github.com/HubSpotEngineering/UIComponents/blob/2b70b8d9ee0be9f39e4b073b89e280e785313d44/HubStyle/static/stylesheets/hubstyle/_templates.sass#L24-L31
 */
export const EDITOR_MODE_CLASSNAME = 'space-sword--editor';